import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TopMenuTemplateService {

  private template!: TemplateRef<any>;

  setTemplate(template: any) {
    this.template = template;
  }

  getTemplate() {
    return this.template;
  }
}
